// Copyright (c) 2019 Deere & Company

import WearPartsClaimContainer from '../../claim/wear-parts/state-connector';

export default {
    component: WearPartsClaimContainer,
    name: 'WEAR_PARTS',
    path: 'wear-parts/new(/:pin)'
};



// WEBPACK FOOTER //
// ./src/routes/claims/wear-parts-claim-route.js